import React, { createContext, useContext, useState, useEffect } from 'react';

const DashboardLanguageContext = createContext();

export const DashboardLanguageProvider = ({ children }) => {
  const [dashboardLanguage, setDashboardLanguage] = useState(() => {
    return localStorage.getItem('dashboard-language') || 'en';
  });

  const [translations, setTranslations] = useState({});

  useEffect(() => {
    const loadTranslations = async () => {
      try {
        const module = await import(`../i18n/translations/dashboard/${dashboardLanguage}.json`);
        setTranslations(module.default);
      } catch (error) {
        console.error(`Failed to load Dashboard translations for ${dashboardLanguage}:`, error);
      }
    };
    loadTranslations();
  }, [dashboardLanguage]);

  useEffect(() => {
    localStorage.setItem('dashboard-language', dashboardLanguage);
  }, [dashboardLanguage]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations;
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key;
      }
    }
    
    return value || key;
  };

  return (
    <DashboardLanguageContext.Provider value={{ dashboardLanguage, setDashboardLanguage, t }}>
      {children}
    </DashboardLanguageContext.Provider>
  );
};

export const useDashboardLanguage = () => {
  const context = useContext(DashboardLanguageContext);
  if (!context) {
    throw new Error('useDashboardLanguage must be used within a DashboardLanguageProvider');
  }
  return context;
};
